import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { WORK_MODES, CONTRACT_TYPES, JOB_LANGUAGES, rwLabel, applyWorkMode } from '@/constants/remoteWork';

const selectCls = 'w-full h-10 px-3 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

export const JobWorkFields = ({ formData, setFormData, testPrefix = 'job' }) => {
  const { i18n } = useTranslation();
  const L = (k) => rwLabel(i18n.language, k);
  const langs = formData.languages || [];
  const toggleLang = (code) => setFormData((prev) => {
    const cur = prev.languages || [];
    return { ...prev, languages: cur.includes(code) ? cur.filter((x) => x !== code) : [...cur, code] };
  });

  return (
    <div className="space-y-4" data-testid={`${testPrefix}-work-fields`}>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label className="text-sm font-semibold text-gray-900">{L('workMode')} <span className="text-red-500">*</span></Label>
          <select
            value={formData.work_mode || 'presencial'}
            onChange={(e) => setFormData((prev) => applyWorkMode(prev, e.target.value))}
            className={`${selectCls} mt-1`}
            data-testid={`${testPrefix}-work-mode-select`}
          >
            {WORK_MODES.map((m) => <option key={m} value={m}>{L(m)}</option>)}
          </select>
        </div>
        <div>
          <Label className="text-sm font-semibold text-gray-900">{L('contractType')}</Label>
          <select
            value={formData.contract_type || ''}
            onChange={(e) => setFormData((prev) => ({ ...prev, contract_type: e.target.value }))}
            className={`${selectCls} mt-1`}
            data-testid={`${testPrefix}-contract-type-select`}
          >
            <option value="">{L('notSpecified')}</option>
            {CONTRACT_TYPES.map((c) => <option key={c} value={c}>{L(c)}</option>)}
          </select>
        </div>
      </div>
      {formData.work_mode === 'remoto' && (
        <p className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2" data-testid={`${testPrefix}-remote-hint`}>
          {L('remoteHint')}
        </p>
      )}
      <div>
        <Label className="text-sm font-semibold text-gray-900">{L('languages')}</Label>
        <div className="flex flex-wrap gap-2 mt-1.5">
          {JOB_LANGUAGES.map((code) => {
            const on = langs.includes(code);
            return (
              <button
                key={code}
                type="button"
                onClick={() => toggleLang(code)}
                aria-pressed={on}
                className={`px-3 py-1.5 rounded-full text-[13px] font-semibold border transition-colors ${on ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400'}`}
                data-testid={`${testPrefix}-lang-${code}`}
              >
                {L(code)}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
